module.exports = __webpack_public_path__ + "img/check-green.2f893889.svg";